import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

// Gate for the /app zone: must be signed in (or in guest mode).
function ProtectedRoute({ children }) {
  const { session, isGuest, loading } = useAuth();
  if (loading) return null;
  if (!session && !isGuest) return <Navigate to="/sign-in" replace />;
  return children;
}

export default ProtectedRoute;
